module.exports = __webpack_public_path__ + "static/media/jackpot-main-background.f14d4a27.png";